import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.5 22.9154C15.3765 22.9154 17.9807 21.7494 19.8657 19.8644C21.7508 17.9793 22.9167 15.3752 22.9167 12.4987C22.9167 9.62224 21.7508 7.01807 19.8657 5.133C17.9807 3.24796 15.3765 2.08203 12.5 2.08203C9.62358 2.08203 7.01942 3.24796 5.13434 5.133C3.2493 7.01807 2.08337 9.62224 2.08337 12.4987C2.08337 15.3752 3.2493 17.9793 5.13434 19.8644C7.01942 21.7494 9.62358 22.9154 12.5 22.9154Z",
      stroke: "#00E25B",
      "stroke-width": "2.08333",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.33337 12.5L11.4584 15.625L17.7084 9.375",
      stroke: "#00E25B",
      "stroke-width": "2.08333",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }